import React from 'react'
import BasicAuthentication from '~/auth/basicAuth'

import logo from '../xmati.png'

const DemoNotAllowedScreen: React.FC = () => {
  const handleLogout = async () => {
    const auth = new BasicAuthentication()
    await auth.logout()
  }
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #fff9db 0%, #ffec99 100%)',
        textAlign: 'center',
        padding: 24,
        boxSizing: 'border-box',
      }}
    >
      <img
        src={logo}
        alt='xMati Logo'
        style={{ width: 120, height: 'auto', marginBottom: 24, userSelect: 'none' }}
        draggable={false}
      />
      <div
        style={{
          fontSize: 23,
          fontWeight: 600,
          color: '#e67700',
          width: '80%',
          maxWidth: 500,
          lineHeight: 1.6,
          wordSpacing: '2px',
          marginBottom: 16,
        }}
      >
        Demo Accounts Not Allowed
      </div>
      <div
        style={{
          fontSize: 16,
          color: '#b35900',
          width: '80%',
          maxWidth: 500,
          lineHeight: 1.5,
          marginBottom: 24,
        }}
      >
        This platform server does not allow demo accounts.
        <br />
        Please upgrade your account or contact support for assistance.
      </div>
      <button
        onClick={handleLogout}
        style={{
          padding: '12px 32px',
          fontSize: 16,
          fontWeight: 600,
          color: '#fff',
          backgroundColor: '#e67700',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          transition: 'all 0.2s',
          boxShadow: '0 2px 8px rgba(230, 119, 0, 0.3)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#cc6900'
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(230, 119, 0, 0.4)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#e67700'
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(230, 119, 0, 0.3)'
        }}
      >
        Logout
      </button>
    </div>
  )
}

export default DemoNotAllowedScreen
